module.exports = __webpack_public_path__ + "img/pago_ok.00149a29.png";